import { ButtonSizes, ButtonStyles, Icons, MenuButton } from '@silverfort/sf-components';
import { FC, SVGProps, useCallback, useEffect, useState } from 'react';
import { SERVICE_ACCOUNT_EXPORT_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { ExportMenuContent } from './ExportMenuContent';

import { ReportManager } from './ReportManager';
import { ReportsMessages, ReportType } from '../../ServiceAccountsTypes';
import { Badge } from '@material-ui/core';
import { useGenerateReport } from '../../hooks/useGenerateReport';
import { useExportFileStatus } from '../../hooks/useExportFileStatus';

export const ServiceAccountsExports = () => {
    const [shouldShowManager, setShouldShowManager] = useState(false);
    const [exportOptionsData, setExportOptionsData] = useState(SERVICE_ACCOUNT_EXPORT_OPTIONS);

    const [managerMessages, setManagerMessages] = useState<ReportsMessages[]>([]);
    const { exportReportStatus, refreshExportReportStatus } = useExportFileStatus();
    const { generateExport } = useGenerateReport();

    const generateExportWrapper = useCallback(
        async (key: ReportType, isJson: boolean) => {
            const id = Math.random() * 10;
            setManagerMessages((messages) => {
                return [...messages, { key, isJson, isLoading: true, id }];
            });
            const response = await generateExport(key, isJson);
            if (response) setExportOptionsData(response);
            setManagerMessages((messages) => {
                return [
                    ...messages.filter((item) => item.id !== id && item.isLoading),
                    { key, isJson, isLoading: false, id: Math.random() * 10 }
                ];
            });
        },
        [generateExport]
    );

    useEffect(() => {
        setExportOptionsData(exportReportStatus);
    }, [exportReportStatus]);

    return (
        <div>
            <Badge variant="dot" color="primary" invisible={managerMessages.length === 0}>
                <MenuButton
                    buttonSize={ButtonSizes.Medium}
                    buttonStyle={ButtonStyles.TertiaryBorder}
                    onButtonClick={() => setShouldShowManager(false)}
                    className="left-[-200px]"
                    content={
                        <ExportMenuContent
                            exportOptionsData={exportOptionsData}
                            generateExport={generateExportWrapper}
                            setShouldShowManager={setShouldShowManager}
                        />
                    }
                    icon={Icons.Download as FC<SVGProps<SVGSVGElement>>}
                    iconClassName="flex"
                    openByDefault={false}
                    buttonTooltipProps={{ title: 'Reports' }}
                />
            </Badge>

            {shouldShowManager && (
                <div className="relative">
                    <div className="block absolute right-0 top-2 z-20">
                        <ReportManager
                            managerMessages={managerMessages}
                            setManagerMessages={setManagerMessages}
                            refreshExportReportStatus={refreshExportReportStatus}
                            exportOptionsData={exportOptionsData}
                            setShouldShowManager={setShouldShowManager}
                            generateExport={generateExportWrapper}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
